// Sections and screens shown on the Screens page. Edit freely.
export const SCREEN_SECTIONS = [
  {
    id: "themes",
    title: "Popular themes",
    subtitle: "Popular investing themes",
    screens: [
      { id: "low-pe-10y", name: "Cheap vs. 10-year average earnings", description: "Stocks trading cheaply relative to their long-term average earnings." },
      { id: "capacity-expansion", name: "Capacity expansion", description: "Companies investing heavily to expand production capacity." },
      { id: "debt-reduction", name: "Debt reduction", description: "Companies steadily paying down their borrowings." },
      { id: "new-high", name: "Companies creating new highs", description: "Stocks trading close to their 52-week high." },
      { id: "no-dilution", name: "Growth without dilution", description: "Growing companies that have not issued many new shares." },
      { id: "institutional-buying", name: "Institutional buying", description: "Stocks where institutional ownership is rising." },
    ],
  },
  {
    id: "formulas",
    title: "Popular formulas",
    subtitle: "Screening formulas based on well-known investing books",
    screens: [
      { id: "piotroski", name: "Piotroski Scan", description: "Companies with a high Piotroski F-Score, a measure of financial strength." },
      { id: "magic-formula", name: "Magic Formula", description: "Ranks companies by earnings yield and return on capital." },
      { id: "coffee-can", name: "Coffee Can Portfolio", description: "Consistent compounders with long records of growth and returns." },
    ],
  },
  {
    id: "price-volume",
    title: "Price or Volume",
    subtitle: "Screens based on price or volume action",
    screens: [
      { id: "darvas", name: "Darvas Scan", description: "Stocks near their 52-week high on strong volume." },
      { id: "golden-cross", name: "Golden Crossover", description: "The 50-day average moves above the 200-day average." },
      { id: "bearish-cross", name: "Bearish Crossovers", description: "The 50-day average falls below the 200-day average." },
      { id: "pv-action", name: "Price Volume Action", description: "Stocks with unusual volume alongside a price move." },
      { id: "rsi-oversold", name: "RSI - Oversold Stocks", description: "Stocks with an RSI below 30." },
    ],
  },
  {
    id: "quarterly",
    title: "Quarterly results",
    subtitle: "Screens around the latest quarterly results",
    screens: [
      { id: "q-growers", name: "Quarterly Growers", description: "Sales and profit rising quarter after quarter." },
      { id: "best-quarter", name: "Best of latest quarter", description: "Companies with the strongest latest-quarter results." },
      { id: "earnings-accel", name: "Earnings acceleration", description: "Companies where profit growth is speeding up." },
      { id: "latest-results", name: "Latest results by date", description: "Newest quarterly reports, listed by announcement date." },
    ],
  },
  {
    id: "valuation",
    title: "Valuation Screens",
    subtitle: "Screens based on stock valuations",
    screens: [
      { id: "high-div", name: "Highest Dividend Yield", description: "Stocks that have consistently paid high dividends." },
      { id: "turnaround", name: "Loss to Profit Turnarounds", description: "Companies that recently moved from losses to profits." },
      { id: "fcf-yield", name: "FCF yield", description: "Companies with strong free cash flow relative to price." },
      { id: "low-peg", name: "Low PEG ratio", description: "Growth at a reasonable price." },
      { id: "high-book", name: "Trading below book value", description: "Stocks priced below their book value per share." },
    ],
  },
];

// Shown in "Popular stock screens" before pressing SHOW ALL SCREENS
export const POPULAR_IDS = [
  "magic-formula",
  "golden-cross",
  "new-high",
  "piotroski",
  "high-div",
  "q-growers",
  "capacity-expansion",
  "fcf-yield",
  "darvas",
];